export class AgentStateEvent {
  constructor(json) {
    this.type = json.Type;
    this.currentState = json.CurrentState;
    this.currentOutReason = json.CurrentOutReason;
    this.startTimeUTC = json.StartTimeUTC;
    this.isAcw = String(json.IsAcw).toLowerCase() === "true";
    this.acwTimer = json.AcwTimeout;
    this.nextStates = json.NextStates;
  }

  get description() {
    return this.currentOutReason
      ? `${this.type} -> ${this.currentState}/${this.currentOutReason}`
      : `${this.type} -> ${this.currentState}`;
  }
}
